import createInlineButtons from './inline-buttons.js';
import createInsertButtons from './insert-buttons.js';
import 'lodash';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-editor-common';
import '../modals.js';
import './image-settings.js';
import 'react';
import 'prop-types';
import 'classnames';
import 'wix-rich-content-common';
import 'wix-rich-content-common/libs/imageUtils';
import 'wix-rich-content-ui-components';
import '../style-inject.es-746bb8ed.js';
import '../consts.js';
import 'ricos-schema';
import '../imageStudio/image-editor.js';
import '../imageStudio/image-editor-logic.js';
import '../imageStudio/image-studio-opener-loader.js';
import '../types.js';
import '../icons/ImageEditorIcon.js';
import '../icons/MediaReplaceIcon.js';
import '../icons/InsertPluginIcon.js';

const createToolbar = ({
  t,
  anchorTarget,
  relValue,
  uiSettings,
  isMobile,
  settings,
  experiments
}) => {
  const disableDownload = uiSettings == null ? void 0 : uiSettings.disableDownload;
  const disableExpand = settings == null ? void 0 : settings.disableExpand;
  return {
    InlineButtons: createInlineButtons({
      t,
      anchorTarget,
      relValue,
      uiSettings,
      isMobile,
      settings,
      experiments
    }),
    InsertButtons: createInsertButtons({
      t,
      settings,
      disableDownload,
      disableExpand,
      experiments
    }),
    name: "image"
  };
};

export { createToolbar as default };
//# sourceMappingURL=createToolbar.js.map
